module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/129.44e67da6.svg";